import { Content } from "@bbnpm/bb-ui-framework";
import styled from "styled-components";

export const StyledContent = styled(Content)`
  .main-content {
    position: relative;
    padding: 2rem;
    width: 100%;
    max-width: 2000px;
    margin: 0 auto;
  }
`;

export const ErrorContent = styled(Content)`
  height: 100%;
  position: fixed;
  width: 100vw;
  left: 0;
  z-index: -1;
  .main-content {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 40%;
    opacity: 50%;
    transform: translateY(-50%);
  }
  h1 {
    font-size: 25em;
    margin: 0;
  }
  h2 {
    font-size: 4em;
    margin: 0;
  }
  h3 {
    font-size: 1em;
    font-weight: normal;
    text-align: left;
    margin: 0;
  }
`;
